import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetBillingReport = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/ReportForBilling?` + params, null);

export const GetPrescriptionReport = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/ReportForPrescription?` + params, null);

export const GetPrescriptionReportHTML5 = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/ReportForPrescriptionHTML5?` + params, null);

export const GetOpdDetailsForReport = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/GetOpdDetailsForReport?` + params, null);

export const GetBillSummaryByPayment = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/GetBillSummaryByPayment?` + params, null);

export const GetBillSummaryByPatient = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/GetBillSummaryByPatient?` + params, null);

export const GetBillSummaryByPatientBilling = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/Report/GetBillSummaryByPatientBilling?` + params,
    null,
  );

export const GetPatientReport = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/PatientReport?` + params, null);

export const GetForm3cForm25Report = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/Form3cForm25Report?` + params, null);

export const GetReportBillingForHTML = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/GetReportBillingForHTML?` + params, null);

export const GetProcedureStatusReport = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/ProcedureStatusReport?` + params, null);

export const GetReportPaymentForHTML = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/GetReportPaymentForHTML?` + params, null);

export const GetBillReport = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Report/BillReport?` + params, null);
